// extracted by mini-css-extract-plugin
export var banner = "exercise-atlas-module--banner--3Gv7I";
export var filters = "exercise-atlas-module--filters--GQtlK";
export var list = "exercise-atlas-module--list--iq2sL";
export var loaderWrapper = "exercise-atlas-module--loader-wrapper--NTeKb";
export var userCant = "exercise-atlas-module--user-cant--FBuZb";
export var userCantButtons = "exercise-atlas-module--user-cant-buttons--y3NIn";
export var userCantText = "exercise-atlas-module--user-cant-text--cvZdl";
export var wrapper = "exercise-atlas-module--wrapper--IcKaf";